import axios from "axios";

export function getReceiveTransferItemProductList(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `/distributor/admin/api/v1/receive-transfer/${parameters.id}/get-transfer-products`,
        {
          params: {
            length: parameters.length,
            start: parameters.start,
          },
        }
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
